import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useBrowserSupport } from '@/shared/composables/browser-api'

declare global {
  interface Window {
    launchQueue: {
      setConsumer: (callback: (launchParams: {
        files: FileSystemHandle[]
        targetURL: URL
      }) => void) => void
    };
  }
}

export const useTelProtocolNumberStore = defineStore('tel-protocol-number', () => {
  const telNumber = ref<string | undefined>()

  const { canUseWindowLocationSearch, canUseLaunchQueue } = useBrowserSupport()

  const updateTelNumber = () => {
    if (canUseWindowLocationSearch()) {
      const params = new URLSearchParams(window.location.search)
      const tel = params.get('tel')
      if (tel) {
        telNumber.value = tel.replaceAll(/[^\d]/g, '')
      } else {
        telNumber.value = undefined
      }
    }
  }

  if (canUseLaunchQueue()) {
    window.launchQueue.setConsumer((launchParams) => {
      if (launchParams.targetURL) {
        const params = new URLSearchParams(new URL(launchParams.targetURL).searchParams)
        const tel = params.get('tel')
        if (tel) {
          telNumber.value = tel.replaceAll(/[^\d]/g, '')
        }
      }
    })
  }

  return {
    telNumber,
    updateTelNumber,
  }
})
